import { isApolloError } from '@apollo/client';

import { IneligibilityReason } from '@ocx/graphql';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { hasGraphQLErrorCode } from '@ocx/apollo-client';

const legacyNotEnoughPointsMessage = 'You do not have enough points for this reward.';

export const isErrorNotEnoughPointsError = (error: unknown): boolean => {
  if (!(error instanceof Error)) {
    return false;
  }
  if (isApolloError(error) && hasGraphQLErrorCode(error, IneligibilityReason.NotEnoughPoints)) {
    return true;
  }
  return error.message.includes(legacyNotEnoughPointsMessage);
};
